/*
 * mtc custom scripts — loaded deferred from snippets/mtc-body-close.liquid.
 * Bespoke behaviours: header scroll state, mega menu, mobile drawer.
 * Deferred, so it runs after the document is parsed (DOM ready).
 */
(function () {
  // Toggle the scrolled state (shrinks the header and, on home, swaps the
  // transparent background for paper). Horizon scrolls the .page-wrapper
  // container (body/html are overflow:hidden), so listen there as well as window.
  var header = document.getElementById('siteHeader');
  if (!header) return;
  var scroller = document.querySelector('.page-wrapper');

  // Keep --mtc-announce-h (first measured inline in mtc-header) current when the bar
  // rewraps on resize or is switched on in the theme editor, as Horizon's header.js
  // does for its own header heights.
  function measureBar() {
    var bar = document.querySelector('#header-group .announcement-bar');
    document.documentElement.style.setProperty('--mtc-announce-h', (bar ? bar.offsetHeight : 0) + 'px');
    if (bar && barObserver) barObserver.observe(bar);
  }
  var barObserver = 'ResizeObserver' in window ? new ResizeObserver(measureBar) : null;
  measureBar();
  document.addEventListener('shopify:section:load', measureBar);
  document.addEventListener('shopify:section:unload', function () { setTimeout(measureBar, 0); });
  function scrollY() {
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, scroller ? scroller.scrollTop : 0);
  }
  var onScroll = function () {
    var scrolled = scrollY() > 8;
    header.classList.toggle('is-scrolled', scrolled);
    // Mirrored at the root so --header-h is readable outside the header, e.g. by
    // sticky elements further down the page.
    document.documentElement.classList.toggle('is-header-scrolled', scrolled);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
})();

// Desktop dropdown hover-intent — keeps the menu open across the trigger/panel gap.
(function () {
  function init() {
    var HIDE_DELAY = 220;
    var items = document.querySelectorAll('.nav-primary > .nav-item, .nav-utility > .nav-item');
    items.forEach(function (item) {
      var menu = item.querySelector(':scope > .mega-menu, :scope > .services-menu');
      if (!menu) return;
      if (item.dataset.mtcHoverBound) return;
      item.dataset.mtcHoverBound = '1';
      var hideTimer = null;
      var trigger = item.querySelector(':scope > [aria-expanded]');
      function isDesktop() { return !window.matchMedia('(max-width: 1080px)').matches; }
      // The CSS also reveals the panel on :focus-within, so aria-expanded has to
      // follow focus as well as pointer state or it reports "collapsed" while open.
      function setExpanded(open) {
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      function show() {
        if (!isDesktop()) return;
        // Stay shut after Escape: returning focus to the trigger fires focusin,
        // which would otherwise immediately re-open what was just dismissed.
        if (item.classList.contains('is-dismissed')) return;
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        item.classList.add('is-hover-open');
        setExpanded(true);
      }
      function scheduleHide() {
        if (!isDesktop()) return;
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function () { item.classList.remove('is-hover-open'); setExpanded(false); hideTimer = null; }, HIDE_DELAY);
      }
      // Re-entering with the pointer is fresh intent, so it lifts a prior dismissal.
      item.addEventListener('mouseenter', function () { item.classList.remove('is-dismissed'); });
      item.addEventListener('mouseenter', show);
      item.addEventListener('mouseleave', scheduleHide);
      menu.addEventListener('mouseenter', show);
      menu.addEventListener('mouseleave', scheduleHide);
      item.addEventListener('focusin', show);
      item.addEventListener('focusout', function (e) {
        if (item.contains(e.relatedTarget)) return;
        item.classList.remove('is-dismissed');
        scheduleHide();
      });
    });
  }

  init();
  // The header is a section, so a theme-editor reload replaces these nodes and any
  // listener bound to the old ones goes with them. Re-running is guarded per element,
  // so a section load elsewhere on the page cannot double-bind.
  document.addEventListener('shopify:section:load', init);
})();

// Mega menu — sidebar tabs reveal the matching panel on hover/focus/click.
(function () {
  function init() {
    function isMobileMq() { return window.matchMedia('(max-width: 1080px)').matches; }
    document.querySelectorAll('.mega-menu').forEach(function (mega) {
      var triggers = mega.querySelectorAll('[data-mega-tab]');
      var panels = mega.querySelectorAll('[data-mega-panel]');
      if (!triggers.length || !panels.length) return;
      if (mega.dataset.mtcTabsBound) return;
      mega.dataset.mtcTabsBound = '1';
      function activate(name) {
        triggers.forEach(function (t) {
          var on = t.getAttribute('data-mega-tab') === name;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === name); });
      }
      var first = triggers[0] && triggers[0].getAttribute('data-mega-tab');
      if (first) activate(first);
      triggers.forEach(function (t) {
        var name = t.getAttribute('data-mega-tab');
        t.addEventListener('mouseenter', function () { if (!isMobileMq()) activate(name); });
        t.addEventListener('focus', function () { if (!isMobileMq()) activate(name); });
        t.addEventListener('click', function (e) {
          e.preventDefault();
          activate(name);
          if (isMobileMq()) mega.classList.add('is-deep'); // mobile: slide to the panel
        });
      });
      mega.querySelectorAll('[data-mega-back]').forEach(function (b) {
        b.addEventListener('click', function () { mega.classList.remove('is-deep'); });
      });
    });
  }

  init();
  // The header is a section, so a theme-editor reload replaces these nodes and any
  // listener bound to the old ones goes with them. Re-running is guarded per element,
  // so a section load elsewhere on the page cannot double-bind.
  document.addEventListener('shopify:section:load', init);
})();

// Mobile off-canvas drawer — burger toggles the overlay; mega/services slide in.
(function () {
  function isMobile() { return window.matchMedia('(max-width: 1080px)').matches; }

  function collapse(item) {
    var t = item.querySelector(':scope > [aria-expanded]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  // Bound once, on window rather than on any header node, so it is left outside init.
  // Reset all drawer state when resizing back to desktop
  window.addEventListener('resize', function () {
    if (isMobile()) return;
    document.body.classList.remove('has-mobile-nav-open');
    document.querySelectorAll('.nav-item.is-mobile-open').forEach(function (n) { n.classList.remove('is-mobile-open'); collapse(n); });
    document.querySelectorAll('.mega-menu.is-deep').forEach(function (m) { m.classList.remove('is-deep'); });
  });

  // The drawer is fixed to the viewport, so it opens at the header's current bottom
  // edge, which sits lower while the announcement bar is still in view. Re-read once
  // the header finishes shrinking and on resize, in case either happens while open.
  function setDrawerTop() {
    var header = document.getElementById('siteHeader');
    if (header) document.documentElement.style.setProperty('--mtc-drawer-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
  }
  function refreshDrawerTop() {
    if (document.body.classList.contains('has-mobile-nav-open')) setDrawerTop();
  }
  window.addEventListener('resize', refreshDrawerTop);

  function init() {
    var toggle = document.querySelector('.nav-mobile-toggle');
    var header = document.getElementById('siteHeader');
    if (!toggle || !header) return;

    if (!header.dataset.mtcDrawerTopBound) {
      header.dataset.mtcDrawerTopBound = '1';
      header.addEventListener('transitionend', function (e) {
        if (e.target === header && e.propertyName === 'height') refreshDrawerTop();
      });
    }

    if (!toggle.dataset.mtcBurgerBound) {
      toggle.dataset.mtcBurgerBound = '1';
      toggle.addEventListener('click', function () {
        if (!isMobile()) return;
        setDrawerTop();
        var open = document.body.classList.toggle('has-mobile-nav-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    // Tap a top-level dropdown trigger -> slide its panel in
    document.querySelectorAll('.nav-primary > .nav-item--has-mega > button, .nav-primary > .nav-item--svc-desktop > a').forEach(function (trigger) {
      if (trigger.dataset.mtcDrawerTriggerBound) return;
      trigger.dataset.mtcDrawerTriggerBound = '1';
      trigger.addEventListener('click', function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        var item = trigger.closest('.nav-item');
        if (item) {
          item.classList.add('is-mobile-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Back buttons slide the panel out (and reset deep mega state)
    document.querySelectorAll('[data-mega-mobile-back], [data-services-back]').forEach(function (b) {
      if (b.dataset.mtcDrawerBackBound) return;
      b.dataset.mtcDrawerBackBound = '1';
      b.addEventListener('click', function () {
        var item = b.closest('.nav-item');
        if (item) { item.classList.remove('is-mobile-open'); collapse(item); }
        var mega = b.closest('.mega-menu');
        if (mega) mega.classList.remove('is-deep');
      });
    });

    // Close the drawer when a real navigation link is tapped. Dropdown triggers are
    // identified by aria-controls - they open a panel rather than navigating.
    document.querySelectorAll('.nav-primary a[href]:not([aria-controls])').forEach(function (a) {
      if (a.dataset.mtcDrawerLinkBound) return;
      a.dataset.mtcDrawerLinkBound = '1';
      a.addEventListener('click', function () {
        var href = a.getAttribute('href');
        if (isMobile() && href && href != '#') {
          document.body.classList.remove('has-mobile-nav-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  init();
  // The header is a section, so a theme-editor reload replaces these nodes and any
  // listener bound to the old ones goes with them. Re-running is guarded per element,
  // so a section load elsewhere on the page cannot double-bind.
  document.addEventListener('shopify:section:load', init);
})();

// Escape unwinds one level at a time, innermost first, and returns focus to the
// control that opened that level so keyboard users don't lose their place.
(function () {
  function collapse(item) {
    var t = item.querySelector(':scope > [aria-expanded]');
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      t.focus();
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;

    var deep = document.querySelector('.mega-menu.is-deep');
    if (deep) {
      deep.classList.remove('is-deep');
      var activeTab = deep.querySelector('[data-mega-tab].is-active');
      if (activeTab) activeTab.focus();
      return;
    }

    var mobileOpen = document.querySelector('.nav-item.is-mobile-open');
    if (mobileOpen) {
      mobileOpen.classList.remove('is-mobile-open');
      collapse(mobileOpen);
      return;
    }

    if (document.body.classList.contains('has-mobile-nav-open')) {
      document.body.classList.remove('has-mobile-nav-open');
      var burger = document.querySelector('.nav-mobile-toggle');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
      return;
    }

    var hoverOpen = document.querySelector('.nav-item.is-hover-open, .nav-item:focus-within');
    if (hoverOpen) {
      hoverOpen.classList.remove('is-hover-open');
      hoverOpen.classList.add('is-dismissed');
      collapse(hoverOpen);
    }
  });
})();

// PDP gallery — clicking a thumbnail scrolls the stage into view (the thumbnail
// grid sits below the stage and may be scrolled past on tall galleries), and
// auto-plays the slide's video/3D model instead of requiring a second click on
// its poster button.
//
// Delegated, because shopify:section:load replaces the gallery subtree in the theme
// editor and listeners bound to the old thumbnails would go with it.
//
// Horizon's slideshow-component reorders <slideshow-slide> DOM nodes for
// non-adjacent jumps (to shorten the scroll animation), so the target slide
// can't be found by its position among slideshow-slide elements at click time
// - look it up by the stable data-media-id product-media.liquid already
// stamps on each slide's media wrapper instead.
//
// <deferred-media>/<product-model> only load on their first showDeferredMedia()
// call - calling it again once already loaded is a no-op, so a video paused via
// its own controls wouldn't restart on a second thumbnail click. Call playMedia()
// directly once the media has already loaded instead of re-clicking the poster.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest?.('.mtc-thumb-grid__item');
    if (!thumb) return;
    const gallery = thumb.closest('media-gallery');
    gallery?.querySelector('slideshow-container')?.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest' });

    const mediaId = thumb.dataset.mediaId;
    if (!mediaId) return;
    const player = gallery
      ?.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`)
      ?.querySelector('deferred-media, product-model');
    if (!player) return;
    if (player.hasAttribute('data-media-loaded')) {
      // showDeferredMedia()'s first-load path dispatches this to pause any other
      // playing media; playMedia() alone does not, so an already-loaded video
      // resuming wouldn't otherwise stop one already playing elsewhere.
      player.dispatchEvent(new Event('media:started-playing', { bubbles: true }));
      player.playMedia?.();
    } else {
      player.showDeferredMedia?.();
    }
  });
})();

(function () {
  var overlay = document.querySelector('[data-mtc-drawer-overlay]');
  if (!overlay) return;
  overlay.addEventListener('click', function () {
    // Close the topmost drawer, not the first in DOM order. Drawers are stacked
    // via --drawer-stack-order, so compare computed z-index rather than position.
    var open = Array.prototype.slice.call(document.querySelectorAll('.theme-drawer__dialog[open]'));
    if (!open.length) return;
    var topmost = open.reduce(function (a, b) {
      var za = parseInt(getComputedStyle(a).zIndex, 10) || 0;
      var zb = parseInt(getComputedStyle(b).zIndex, 10) || 0;
      return zb >= za ? b : a;
    });
    var closeButton = topmost.querySelector('.theme-drawer__close-button');
    if (closeButton) closeButton.click();
  });
})();

// Listing head bar (collection + search): Show/Hide Filters state and the
// stuck state of the sticky bar. State lives on <html> so it survives the
// section swaps Horizon performs when filters or sorting are applied.
(function () {
  var FILTERS_OPEN_CLASS = 'mtc-filters-open';

  // Deliberately not set on a fresh page load: this file is deferred, so opening
  // here would paint the closed layout and then shift it. main-collection-mtc and
  // search-results-mtc set it inline instead when their "Show filters by default"
  // setting is on. The class is on <html>, which a section swap does not replace,
  // so the shopper's choice survives applying a filter or a sort.
  function syncToggleState() {
    var expanded = String(document.documentElement.classList.contains(FILTERS_OPEN_CLASS));
    var toggles = document.querySelectorAll('[data-mtc-filter-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].getAttribute('aria-expanded') !== expanded) {
        toggles[i].setAttribute('aria-expanded', expanded);
      }
    }
  }

  syncToggleState();

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-mtc-filter-toggle]')) return;

    document.documentElement.classList.toggle(FILTERS_OPEN_CLASS);
    syncToggleState();
  });

  // A filter or sort re-renders the section and Horizon fires no event for it, so
  // the replacement toggle arrives with the Liquid default while the sidebar is
  // still open. childList only, so setting the attribute cannot retrigger this.
  var listingObserver = new MutationObserver(syncToggleState);

  // Rebound rather than pointed at document.body once, so the observer watches the
  // narrowest subtree that can contain the toggle. Falls back to body before the
  // first paint of a listing, when .listing is not in the document yet.
  function observeListing() {
    listingObserver.disconnect();
    listingObserver.observe(document.querySelector('.listing') || document.body, {
      childList: true,
      subtree: true,
    });
  }

  observeListing();

  // A storefront filter morphs .listing in place, so the observer survives it. A
  // theme-editor section reload replaces the node outright, which leaves the
  // observer watching a detached tree, so rebind and re-sync on that event.
  document.addEventListener('shopify:section:load', function (event) {
    // Only the theme editor fires this, so re-applying the section's default here follows
    // the setting without overriding a shopper's choice after filtering.
    var listing = event.target instanceof Element && event.target.querySelector('.listing[data-mtc-filters-open-default]');
    if (listing) {
      document.documentElement.classList.toggle(
        FILTERS_OPEN_CLASS,
        listing.getAttribute('data-mtc-filters-open-default') === 'true'
      );
    }
    observeListing();
    syncToggleState();
    // The replacement bar renders without is-stuck, so a reload while the page is
    // already past the threshold leaves it unstuck until the next scroll.
    markStuck();
  });

  // The bar is re-queried on every scroll rather than cached, so the stuck
  // state survives the section swaps Horizon performs when filtering.
  function markStuck() {
    var head = document.querySelector('.listing__head');
    if (!head) return;

    var offset = parseFloat(getComputedStyle(head).top) || 0;
    head.classList.toggle('is-stuck', head.getBoundingClientRect().top <= offset + 1);
  }

  var pageScroller = document.querySelector('.page-wrapper');
  markStuck();
  window.addEventListener('scroll', markStuck, { passive: true });
  if (pageScroller) pageScroller.addEventListener('scroll', markStuck, { passive: true });
})();

// Off-screen carousel slides are marked aria-hidden by Horizon but keep their
// links in the tab order, which axe reports as focusable content inside hidden
// content. Mirror the state with inert.
(function () {
  var SLIDE = 'slideshow-slide';

  // Mirrors one slide's aria-hidden state onto inert, moving focus out first if the
  // slide is about to become inert while holding it.
  function sync(slide) {
    if (slide.getAttribute('aria-hidden') === 'true') {
      // inert blurs whatever it contains, and the slideshow does not pause autoplay
      // on focus, so a slide can be hidden while holding the keyboard position.
      // Hand focus to the slideshow first, otherwise it falls back to <body> and the
      // visitor restarts from the top of the document.
      if (slide.contains(document.activeElement)) {
        var host = slide.closest('slideshow-component') || slide.parentElement;
        var target = host && (host.querySelector('[ref="next"]') || host);
        if (target) {
          if (!target.hasAttribute('tabindex') && target === host) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        } else {
          document.activeElement.blur();
        }
      }
      slide.setAttribute('inert', '');
    } else {
      slide.removeAttribute('inert');
    }
  }

  // Syncs every slide in a subtree, and the subtree itself when the inserted node is
  // the slide rather than a wrapper around it.
  function syncAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SLIDE).forEach(sync);
    if (scope !== document && scope.matches && scope.matches(SLIDE)) sync(scope);
  }

  syncAll(document);

  // Two mutation kinds matter. An aria-hidden flip on an existing slide, and a slide
  // ARRIVING already marked aria-hidden - a section re-render inserts the whole
  // subtree at once, which produces no attribute record for it at all.
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') {
        var target = record.target;
        if (target.matches && target.matches(SLIDE)) sync(target);
        return;
      }
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) syncAll(node);
      });
    });
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });
})();

// Every piece is one of a kind, so the cart stepper has nothing to step. CSS hides it, but a
// hidden input is still submittable and still reachable by assistive tech, so disable the
// controls as well. Cart actions re-render the line items, so this re-applies on insertion
// rather than running once.
(function () {
  var CART_QTY = 'cart-quantity-selector-component';

  function disableWithin(root) {
    if (!root || !root.querySelectorAll) return;
    var comps = [];
    if (root.matches && root.matches(CART_QTY)) comps.push(root);
    root.querySelectorAll(CART_QTY).forEach(function (c) {
      comps.push(c);
    });
    comps.forEach(function (component) {
      component.querySelectorAll('input, button').forEach(function (el) {
        if (!el.disabled) el.disabled = true;
      });
    });
  }

  disableWithin(document);

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) disableWithin(node);
      });
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    // The cart component manages these buttons client-side and re-enables them after
    // every update, so watching childList alone let the disable be undone.
    attributes: true,
    attributeFilter: ['disabled'],
  });
})();

// Uploaded videos in mtc video blocks. They autoplay, so the browser pulled the whole file at
// page load even for a block far below the fold. video-mtc parks the source and the poster;
// attach them shortly before the block scrolls into view.
(function () {
  var MARGIN = '400px';

  var io = null;
  var watched = [];

  function forget(target) {
    io.unobserve(target);
    var i = watched.indexOf(target);
    if (i !== -1) watched.splice(i, 1);
  }

  function attachPoster(video) {
    var poster = video.getAttribute('data-mtc-poster');
    if (!poster) return;
    video.setAttribute('poster', poster);
    video.removeAttribute('data-mtc-poster');
  }

  function attachSources(scope) {
    var deferred = scope.querySelectorAll('source[data-mtc-src]');
    if (!deferred.length) return false;
    deferred.forEach(function (source) {
      source.setAttribute('src', source.getAttribute('data-mtc-src'));
      source.removeAttribute('data-mtc-src');
    });
    return true;
  }

  // Horizon's video snippet emits the markup twice: the live copy, and an inert <template>
  // that its poster button clones on click. The capture in video-mtc parks the source on
  // both, so both need attaching - a template left parked clones a video with no source,
  // and with autoplay off the template is the only copy there is.
  function activate(target) {
    target.querySelectorAll('template').forEach(function (template) {
      template.content.querySelectorAll('video[data-mtc-poster]').forEach(attachPoster);
      attachSources(template.content);
    });

    var live = target.matches('video[data-mtc-lazy-video]')
      ? [target]
      : Array.prototype.slice.call(target.querySelectorAll('video[data-mtc-lazy-video]'));

    live.forEach(function (video) {
      attachPoster(video);
      if (!attachSources(video)) return;
      video.removeAttribute('data-mtc-lazy-video');
      video.load();
      // Only a video that was going to autoplay should start on its own. Horizon's own
      // deferred-media guards its play() the same way.
      if (!video.autoplay) return;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    });
  }

  // Observe the deferred-media wrapper rather than the video, so the template beside it is
  // in reach. With autoplay off there is no live video to find, only the template.
  function pending(scope) {
    var targets = [];
    var add = function (node) {
      if (node && targets.indexOf(node) === -1) targets.push(node);
    };
    scope.querySelectorAll('video[data-mtc-lazy-video]').forEach(function (video) {
      add(video.closest('deferred-media') || video);
    });
    scope.querySelectorAll('deferred-media > template').forEach(function (template) {
      if (template.content.querySelector('source[data-mtc-src]')) add(template.parentNode);
    });
    return targets;
  }

  function observe(root) {
    var scope = root && root.querySelectorAll ? root : document;
    // Prune before the early return: a replaced section usually brings nothing new to
    // observe, and that is exactly when its detached targets need releasing.
    if (io) {
      watched = watched.filter(function (target) {
        if (document.contains(target)) return true;
        io.unobserve(target);
        return false;
      });
    }
    var targets = pending(scope);
    if (!targets.length) return;
    // No IntersectionObserver means no way to defer safely, so load everything rather than
    // leave a visitor looking at a poster that never becomes a video.
    if (!('IntersectionObserver' in window)) {
      targets.forEach(activate);
      return;
    }
    // One observer for the life of the page. A fresh one per section load leaked the old
    // one, and its detached targets with it, on every theme-editor edit.
    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            activate(entry.target);
            forget(entry.target);
          });
        },
        { rootMargin: MARGIN }
      );
    }
    targets.forEach(function (target) {
      if (watched.indexOf(target) !== -1) return;
      watched.push(target);
      io.observe(target);
    });
  }

  observe(document);
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target && event.target.querySelectorAll ? event.target : document);
  });
})();

// Hero videos shown on one side of the 750px breakpoint only. hero-mtc parks the source on
// data-mtc-src - the desktop video when the mobile slot has its own media, and every mobile
// video - so a device never fetches a file it cannot display: the other side's container is
// display:none, and CSS hiding alone does not stop an autoplaying video buffering. Attach
// each source only on its own side of the breakpoint.
(function () {
  var DESKTOP = '(min-width: 750px)';
  var mq = window.matchMedia(DESKTOP);

  function activate(video, attr) {
    var deferred = video.querySelectorAll('source[data-mtc-src]');
    if (!deferred.length) return;
    deferred.forEach(function (source) {
      source.setAttribute('src', source.getAttribute('data-mtc-src'));
      source.removeAttribute('data-mtc-src');
    });
    video.removeAttribute(attr);
    video.load();
    var played = video.play();
    // Autoplay can still be refused (power saving, data saver); the poster stays visible.
    if (played && played.catch) played.catch(function () {});
  }

  function sync() {
    var attr = mq.matches ? 'data-mtc-desktop-video' : 'data-mtc-mobile-video';
    document.querySelectorAll('video[' + attr + ']').forEach(function (video) {
      activate(video, attr);
    });
  }

  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);
  document.addEventListener('shopify:section:load', sync);
})();
